import { OverridableStringUnion } from "@mui/types";
import {
  TypographyPropsVariantOverrides,
  TypographyVariant,
} from "@mui/material";

import {
  GetAccomodationMasterResp,
  getAuthorizationTypeMaster,
  getCareCoordinationProgram,
  getCareType,
  getDocumentSource,
  getDocumentTypeForPriorAuth,
  getHealthProgram,
  getIcdCodeTypeData,
  GetLanguageMasterResp,
  getNonCoveredService,
  getOrderAcceptor,
  getOrderingSource,
  getPriorAuthReferralSourceMasterResp,
  getPsychologicalHistory,
  getReferralMgmtSystem,
  getServiceStatusMaster,
  getServiceStatusReasonMaster,
} from "../actions/Master";
import {
  getPriorAuthReceivedMethodMasterResp,
  getRelationshipMasterResp,
  getUrgencyStatusMasterResp,
} from "../actions/Patient";
import { Type } from "../models/HealthPlan";
import {
  ADMIN_LIST_PAGE_SIZE,
  DEFAULT_PAGE,
  DISCIPLINE_PER_PAGE,
  PER_PAGE,
} from "./FunctionalUtils";
import {
  PriorAuthReceivedMethodActionDispatchTypes,
  RelationshipActionDispatchTypes,
  UrgencyStatusActionDispatchTypes,
} from "./Patient";
import {
  AccomodationMasterActionDispatchTypes,
  AuthorizationTypeMasterActionDispatchTypes,
  CareCoordinationProgramActionDispatchTypes,
  CareTypeActionDispatchTypes,
  DocumentSourceActionDispatchTypes,
  DocumentTypeForPriorAuthActionDispatchTypes,
  HealthProgramActionDispatchTypes,
  IcdCodeTypeActionDispatchTypes,
  LanguageMasterActionDispatchTypes,
  NonCoveredServicesActionDispatchTypes,
  OrderAcceptorActionDispatchTypes,
  OrderingSourceActionDispatchTypes,
  PriorAuthReferralSourceActionDispatchTypes,
  PsychologicalHistoryActionDispatchTypes,
  ReferralManagementSystemActionDispatchTypes,
  ServiceStatusMasterActionDispatchTypes,
  ServiceStatusReasonActionDispatchTypes,
} from "./Master";

export enum TrackingLabels {
  MODULE_RESPONSE = "Module Response",
  SUB_MODULE_RESPONSE = "Sub Module Response",
}

export enum referralPageIds {
  CREATE_NEW_REFERRAL = 1,
  REFERRAL_SOURCE_DETAILS = 2,
  INSURANCE_DETAILS = 3,
  PHYSICIAN_DETAILS = 4,
}

export const inputType = {
  patientImage: "patientImage",
  patientDocs: "patientDocs",
  profilePicture: "profilePicture",
  referralDocs: "referralDocs",
  userProfile: "userProfile",
};

export enum PatientPreferredLanguage {
  SPANISH = "SPANISH",
  ENGLISH = "ENGLISH",
  CHINESE = "CHINESE",
  ARABIC = "ARABIC",
  NULL = "NULL"
}

export const PatientLanguages = {
  ENGLISH: "English",
  SPANISH: "Spanish",
  CHINESE: "Chinese",
  ARABIC: "Arabic",
};

export const PatientEnglishLanguage = ["ENGLISH", "English", "Eng", "es-Us"]

export const PatientSpanishLanguage = ["SPANISH", "Spanish", "Spa", "en-Es"]

export const PatientChineseLanguage = ["CHINESE", "Chinese", "chi (B)", "zho (T)", "zh", "CHI"]

export const PatientArabicLanguage = ["ARABIC", "Arabic", "ara", "ar"]

export const LANGUAGE_KEYWORDS = {
  ENGLISH: PatientEnglishLanguage,
  SPANISH: PatientSpanishLanguage,
  CHINESE: PatientChineseLanguage,
  ARABIC: PatientArabicLanguage,
};

export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
  UNKNOWN = "Unknown",
}

export enum RequesterComponentInjectType {
  PRIOR_AUTH = "priorAuth",
  AUTH_DETAILS = "authDetails",
}

export enum VirtualizeAutocompleteInjectType {
  SERVICE_PROVIDER_NPI = "search-by-provider-name-npi",
}

export enum NppsSearchInjectedto {
  PATIENT_HEADER = "patient-header",
}
export const GENDER_DROPDOWN_OPTIONS: Type[] = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
  {
    label: "Unknown",
    value: "Unknown",
  },
];

export const WOUND_CARE_SHOW_RECORDS: any[] = [
  {
    label: "Last 10",
    value: "10",
  },
  {
    label: "Last 20",
    value: "20",
  },
  {
    label: "Last 30",
    value: "30",
  },
];

export enum NotifyInternalDataType {
  PRIOR_AUTH_REQUEST_EMERGENCY_CONTACT = "PRIOR_AUTH_REQUEST_EMERGENCY_CONTACT",
  PATIENT_HEADER_EMERGENCY_CONTACT = "PATIENT_HEADER_EMERGENCY_CONTACT",
  PRIOR_AUTH_REQUEST_PRIMARY_PHYSICIAN_INFO = "PRIOR_AUTH_REQUEST_PRIMARY_PHYSICIAN_INFO",
}

export const DISCIPLINE_DETAILS = true;
export const URGENCY_STATUS_EXPEDITED_ID = 2;
export const REQUEST_FACILITY_NAME = "Health Plan Case Manager";

export const requiredFieldMsg = {
  EMERGENCY_CONTACT_NAME: "Contact name is required.",
};

export enum EmergencyContactTypes {
  ALTERNATE_CONTACT = "ALTERNATE_CONTACT",
  REQUEST_EMERGENCY_CONTACT = "REQUEST_EMERGENCY_CONTACT",
}

export enum DocFilterList {
  DOCUMENT_NO = "documentNo",
  DOCUMENT_NAME = "documentName",
  DOCUMENT_DATE_TIME = "documentDateTime",
  DOCUMENT_SOURCE = "documentSource",
  DOCUMENT_TYPE = "documentType",
  DOCUMENT_CREATED_BY = "documentCreatedBy",
  DOCUMENT_FAX_STATUS = "documentFaxStatus",
  DOCUMENT_ACTION = "documentAction",
}

export const HeaderLabelDocumentReview = [
  {
    label: "DOC NO.",
    width: "7%",
    displayIcon: false,
    isDocNo: true,
    tableKeyName: "",
    showFilterIcon: DocFilterList.DOCUMENT_NO,
    filterIcon: false,
  },
  {
    label: "DOCUMENT NAME",
    width: "17%",
    displayIcon: false,
    isDocNo: false,
    showFilterIcon: DocFilterList.DOCUMENT_NAME,
    filterIcon: false,
  },
  {
    label: "DATE / TIME",
    width: "16%",
    displayIcon: false,
    isDocNo: false,
    showFilterIcon: DocFilterList.DOCUMENT_DATE_TIME,
    filterIcon: false,
  },
  {
    label: "SOURCE",
    width: "7%",
    displayIcon: false,
    isDocNo: false,
    showFilterIcon: DocFilterList.DOCUMENT_SOURCE,
    filterIcon: false,
  },
  {
    label: "DOC TYPE",
    width: "16%",
    displayIcon: false,
    isDocNo: false,
    showFilterIcon: DocFilterList.DOCUMENT_TYPE,
    filterIcon: false,
  },
  {
    label: "CREATED BY",
    width: "15%",
    displayIcon: false,
    isDocNo: false,
    showFilterIcon: DocFilterList.DOCUMENT_CREATED_BY,
    filterIcon: false,
  },
  {
    label: "ACTIONS",
    width: "8%",
    displayIcon: false,
    isDocNo: false,
    showFilterIcon: DocFilterList.DOCUMENT_ACTION,
    filterIcon: false,
  },
  {
    label: "FAX STATUS",
    width: "8%",
    displayIcon: false,
    isDocNo: false,
    showFilterIcon: DocFilterList.DOCUMENT_FAX_STATUS,
    filterIcon: false,
  },
];

export enum LofHeaderNames {
  FUNCTIONAL_MOBILITY = "FunctionalMobility",
  ADLS = "ADLS",
  LIVING_STATUS = "livingStatus",
  AVAILABLE_ASSISTANCE = "AvailableAssistance",
  BED_MOBILITY = "BedMobility",
  TRANSFER_SIT_TO_STAND = "TransferSitToStand",
  TOILETING_HYGIENE = "ToiletingHygiene",
  TRANSFER_TOILET = "TransferToilet",
  TRANSFER_TUB_SHOWER = "TransferTubShower",
  BATHING_SHOWERING = "BathingShowering",
  LOWER_BODY_DRESSING = "LowerBodyDressing",
  UPPER_BODY_DRESSING = "UpperBodyDressing",
  GROOMING = "Grooming",
  AMBULATION = "Ambulation",
  INPATIENT = "Inpatient",
  CURRENT = "Current",
  UPPER_EXTREMITIES = "UpperExtremities",
  LOWER_EXTREMITIES = "LowerExtremities",
  CURRENT_DEVICES = "CurrentDevices",
  PRIOR_DEVICES = "PriorDevices",
  RECOMMENDED_DEVICES = "RecommendedDevices",
  OTHER_DEVICES = "OtherDevices",
  ESTABLISHED = "Established",
  PLAN_TO_ESTABLISH_HEP = "PlanToEstablishHep",
}

export enum WHHeaderNames {
  LOCATION = "Location",
  FIRST_REVIEW_DATE = "FirstReviewDate",
  REVIEWED_BY = "ReviewedBy",
  STAGE = "Stage",
  THICKNESS = "Thickness",
  MEASUREMENT_LENGTH = "MeasurementLength",
  MEASUREMENT_WIDTH = "MeasurementWidth",
  MEASUREMENT_DEPTH = "MeasurementDepth",
  DRAINAGE = "Drainage",
  DRAINAGE_AMOUNT = "DrainageAmount",
  TUNNELING = "Tunneling",
  UNDERMINING = "Undermining",
  WOUND_BED_TISSUE = "WoundBedTissue",
  WOUND_EDGES = "WoundEdges",
  INDICATION_OF_INFECTION = "IOI",
  INTERVENTIONS_FOR_HEALING = "IFH",
  CONDITIONS_AFFECTING_HEALING = "CAH",
  DRESSINGS = "Dressings",
  WOUND_CARE_INSRUCTIONS = "WCI",
  COMMENT = "comment",
}

export enum LOFLabelNames {
  PLOF = "PLOF",
  CLOF = "CLOF",
  AMBULATION_DISTANCE = "Ambulation Distance",
  WEIGHT_BEARING_STATUS = "Weight Bearing Status",
  ASSISTIVE_DEVICES = "Assistive devices",
  HEP = "HEP",
  LIVING_STATUS_LABEL = "Living status",
  AVAILABLE_ASSISTANCE_LABEL = "Available assistance",
  PRIOR_ASSISTIVE_DEVICES = "Prior Assistive Devices",
  INPT_CURRENT_LOF = "Inpt/Current LOF",
}

export const DefaultLOF = [
  {
    key: LOFLabelNames.PLOF,
    value: LOFLabelNames.PLOF,
    LOF: [
      {
        key: LofHeaderNames.FUNCTIONAL_MOBILITY,
        label: "Functional Mobility",
        keyPath: "PLOF.Functional Mobility",
        identityPath: "PLOF LOA",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.ADLS,
        label: "ADLS",
        keyPath: "PLOF.ADLs",
        identityPath: "PLOF LOA",
        borderRequired: true,
      },
    ],
  },
  {
    key: LOFLabelNames.CLOF,
    value: LOFLabelNames.CLOF,
    LOF: [
      {
        key: LofHeaderNames.LIVING_STATUS,
        label: "Living Status",
        keyPath: "",
        identityPath: "Living status",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.AVAILABLE_ASSISTANCE,
        label: "Available Assistance",
        keyPath: "",
        identityPath: "Available assistance",
        borderRequired: true,
      },
      {
        key: LofHeaderNames.BED_MOBILITY,
        label: "Bed Mobility",
        keyPath: "Inpt/Current LOF.Bed Mobility",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.TRANSFER_SIT_TO_STAND,
        label: "Transfer: Sit to Stand",
        keyPath: "Inpt/Current LOF.Transfer:sittostand",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.TOILETING_HYGIENE,
        label: "Toileting/Hygiene",
        keyPath: "Inpt/Current LOF.Toileting/Hygiene",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.TRANSFER_TOILET,
        label: "Transfer: Toilet",
        keyPath: "Inpt/Current LOF.Transfer:toilet",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.TRANSFER_TUB_SHOWER,
        label: "Transfer: Tub/Shower",
        keyPath: "Inpt/Current LOF.Transfer:tub/shower",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.BATHING_SHOWERING,
        label: "Bathing/Showering",
        keyPath: "Inpt/Current LOF.Bathing/Showering",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.LOWER_BODY_DRESSING,
        label: "Lower Body Dressing",
        keyPath: "Inpt/Current LOF.Lower Body Dressing",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.UPPER_BODY_DRESSING,
        label: "Upper Body Dressing",
        keyPath: "Inpt/Current LOF.Upper Body Dressing",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.GROOMING,
        label: "Grooming",
        keyPath: "Inpt/Current LOF.Grooming",
        identityPath: "CLOF",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.AMBULATION,
        label: "Ambulation",
        keyPath: "Inpt/Current LOF.Row 5",
        identityPath: "CLOF",
        borderRequired: true,
      },
    ],
  },
  {
    key: LOFLabelNames.AMBULATION_DISTANCE,
    value: LOFLabelNames.AMBULATION_DISTANCE,
    LOF: [
      {
        key: LofHeaderNames.INPATIENT,
        label: "Inpatient",
        keyPath: "Ambulation.Inpt",
        identityPath: "",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.CURRENT,
        label: "Current",
        keyPath: "Ambulation.Current",
        identityPath: "",
        borderRequired: true,
      },
    ],
  },
  {
    key: LOFLabelNames.WEIGHT_BEARING_STATUS,
    value: LOFLabelNames.WEIGHT_BEARING_STATUS,
    LOF: [
      {
        key: LofHeaderNames.UPPER_EXTREMITIES,
        label: "Upper Extremities",
        keyPath: "Weight Bearing Status.UpperExtremities.LOA",
        identityPath: "",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.LOWER_EXTREMITIES,
        label: "Lower Extremities",
        keyPath: "Weight Bearing Status.LowerExtremities.LOA",
        identityPath: "",
        borderRequired: true,
      },
    ],
  },
  {
    key: LOFLabelNames.ASSISTIVE_DEVICES,
    value: LOFLabelNames.ASSISTIVE_DEVICES,
    LOF: [
      {
        key: LofHeaderNames.PRIOR_DEVICES,
        label: "Prior devices",
        keyPath: "Prior Assistive Devices",
        identityPath: "",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.CURRENT_DEVICES,
        label: "Current devices",
        keyPath: "current Assistive Devices",
        identityPath: "",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.RECOMMENDED_DEVICES,
        label: "Recommended devices",
        keyPath: "recommended Assistive Devices",
        identityPath: "",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.OTHER_DEVICES,
        label: "Other devices",
        keyPath: "Other devices",
        identityPath: "",
        borderRequired: true,
      },
    ],
  },
  {
    key: LOFLabelNames.HEP,
    value: LOFLabelNames.HEP,
    LOF: [
      {
        key: LofHeaderNames.ESTABLISHED,
        label: "Established",
        keyPath: "HEP established",
        identityPath: "",
        borderRequired: false,
      },
      {
        key: LofHeaderNames.PLAN_TO_ESTABLISH_HEP,
        label: "Plan to Establish HEP",
        keyPath: "Plan to Establish HEP",
        identityPath: "",
        borderRequired: false,
      },
    ],
  },
];

export const DefaultWoundHistory = [
  {
    key: "Review",
    value: "Review",
    WH: [
      {
        key: WHHeaderNames.LOCATION,
        label: "Location",
        keyPath: "Location",
        identityPath: "Location",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.FIRST_REVIEW_DATE,
        label: "First Review Date",
        keyPath: "firstreviewdate",
        identityPath: "firstreviewdate",
        borderRequired: true,
      },
      {
        key: WHHeaderNames.REVIEWED_BY,
        label: "Reviewed By",
        keyPath: "ReviewedBy",
        identityPath: "ReviewedBy",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.STAGE,
        label: "Stage",
        keyPath: "Stage",
        identityPath: "Stage",
        borderRequired: true,
      },
      {
        key: WHHeaderNames.THICKNESS,
        label: "Thickness",
        keyPath: "Thickness",
        identityPath: "Thickness",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.MEASUREMENT_LENGTH,
        label: "Measurement Length",
        keyPath: "MeasurementLength",
        identityPath: "MeasurementLength",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.MEASUREMENT_WIDTH,
        label: "Measurement Width",
        keyPath: "MeasurementWidth",
        identityPath: "MeasurementWidth",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.MEASUREMENT_DEPTH,
        label: "Measurement Depth",
        keyPath: "MeasurementDepth",
        identityPath: "MeasurementDepth",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.DRAINAGE,
        label: "Drainage",
        keyPath: "Drainage",
        identityPath: "Drainage",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.DRAINAGE_AMOUNT,
        label: "Drainage Amount",
        keyPath: "DrainageAmount",
        identityPath: "DrainageAmount",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.TUNNELING,
        label: "Tunneling",
        keyPath: "Tunneling",
        identityPath: "Tunneling",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.UNDERMINING,
        label: "Undermining",
        keyPath: "Undermining",
        identityPath: "Undermining",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.WOUND_BED_TISSUE,
        label: "Wound Bed Tissue",
        keyPath: "WoundBedTissue",
        identityPath: "WoundBedTissue",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.WOUND_EDGES,
        label: "Wound Edges",
        keyPath: "WoundEdges",
        identityPath: "WoundEdges",
        borderRequired: true,
      },
      {
        key: WHHeaderNames.INDICATION_OF_INFECTION,
        label: "Indication Of Infection",
        keyPath: "IOI",
        identityPath: "",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.INTERVENTIONS_FOR_HEALING,
        label: "Interventions For Healing",
        keyPath: "IFH",
        identityPath: "IFH",
        borderRequired: true,
      },
      {
        key: WHHeaderNames.CONDITIONS_AFFECTING_HEALING,
        label: "Conditions Affecting Healing",
        keyPath: "CAH",
        identityPath: "CAH",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.DRESSINGS,
        label: "Dressings",
        keyPath: "Dressings",
        identityPath: "Dressings",
        borderRequired: true,
      },
      {
        key: WHHeaderNames.WOUND_CARE_INSRUCTIONS,
        label: "Wound Care Instructions",
        keyPath: "WCI",
        identityPath: "WCI",
        borderRequired: false,
      },
      {
        key: WHHeaderNames.COMMENT,
        label: "Comment",
        keyPath: "comment",
        identityPath: "comment",
        borderRequired: false,
      },
    ],
  },
];

export const DefaultPaginationData = {
  pageNo: DEFAULT_PAGE,
  pageSize: PER_PAGE,
};

export const DefaultReferralNotePagination = {
  pageNo: DEFAULT_PAGE,
  pageSize: DISCIPLINE_PER_PAGE,
};

export enum DenialRationaleFilterConst {
  DENIAL_RATIONALE_DISCIPLINE = "discipline",
  DENIAL_RATIONALE_TEMPLATE = "template",
  DENIAL_RATIONALE_SERVICEREQUEST = "serviceRequest",
  DENIAL_RATIONALE_RATIONALEDECISION = "rationaleDecision",
}

export const WoundCareDisciplinesPaginationData = {
  pageNo: DEFAULT_PAGE,
  pageSize: ADMIN_LIST_PAGE_SIZE,
};

export const getMasterApiCall: any = (name: string) => {
  switch (name) {
    case RelationshipActionDispatchTypes.GET_RELATIONSHIP_SUCCESS:
      return getRelationshipMasterResp();
    case UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS:
      return getUrgencyStatusMasterResp();
    case NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_SUCCESS:
      return getNonCoveredService();
    case OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_SUCCESS:
      return getOrderingSource();
    case OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_SUCCESS:
      return getOrderAcceptor();
    case IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_SUCCESS:
      return getIcdCodeTypeData();
    case HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_SUCCESS:
      return getHealthProgram();
    case CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_SUCCESS:
      return getCareCoordinationProgram();
    case PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_SUCCESS:
      return getPsychologicalHistory();
    case DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_SUCCESS:
      return getDocumentSource();
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS:
      return GetLanguageMasterResp();
    case AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_SUCCESS:
      return GetAccomodationMasterResp();
    case AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_SUCCESS:
      return getAuthorizationTypeMaster();
    case ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS:
      return getReferralMgmtSystem();
    case CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS:
      return getCareType();
    case PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_SUCCESS:
      return getPriorAuthReceivedMethodMasterResp();
    case PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS:
      return getPriorAuthReferralSourceMasterResp();
    case DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS:
      return getDocumentTypeForPriorAuth();
    case ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_SUCCESS:
      return getServiceStatusMaster();
    case ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_SUCCESS:
      return getServiceStatusReasonMaster();
  }
};

export type VariantType =
  | OverridableStringUnion<
      "inherit" | TypographyVariant,
      TypographyPropsVariantOverrides
    >
  | undefined;

export const PriorAuthMasterApiKey = "PriorAuthMasterApiKey";
export const DataPresentInLocalStorage = "Data available in LocalStorage"
export const OriginalPrimary = "ORIGINAL PRIMARY";
export const RELATIONSHIP_TYPE_DEPENDENT = 2

export const CANCEL_STATUS_ID = 7;
export const ALLOWED_CANCEL_REASON_IDS = [46, 47];
